import React, { useState, useEffect } from 'react';
import axios from 'axios';

const RekapAsramaPengayaan = ({ token }) => {
  const [activeTab, setActiveTab] = useState('sholat'); // 'sholat' atau 'pengayaan'
  
  // Master Data State
  const [asramaList, setAsramaList] = useState([]);
  const [pengayaanList, setPengayaanList] = useState([]);
  
  // Filter State
  const [selectedAsrama, setSelectedAsrama] = useState('');
  const [selectedPengayaan, setSelectedPengayaan] = useState('');
  const [tanggal, setTanggal] = useState(new Date().toISOString().split('T')[0]);
  
  // Result State
  const [dataRekap, setDataRekap] = useState([]);
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:10000/api';
  const authHeader = { headers: { Authorization: `Bearer ${token}` } };

  useEffect(() => {
    fetchMasterData();
  }, []);

  useEffect(() => {
    if (activeTab === 'sholat' && selectedAsrama) {
      fetchRekapSholat();
    } else if (activeTab === 'pengayaan' && selectedPengayaan) {
      fetchRekapPengayaan();
    }
  }, [activeTab, selectedAsrama, selectedPengayaan, tanggal]);

  const fetchMasterData = async () => {
    try {
      const [resAsrama, resPengayaan] = await Promise.all([
        axios.get(`${API_URL}/asrama`, authHeader),
        axios.get(`${API_URL}/pengayaan`, authHeader)
      ]);
      
      setAsramaList(resAsrama.data);
      if (resAsrama.data.length > 0) setSelectedAsrama(resAsrama.data[0].id);

      setPengayaanList(resPengayaan.data);
      if (resPengayaan.data.length > 0) setSelectedPengayaan(resPengayaan.data[0].id);
    } catch (err) {
      console.error('Gagal mengambil data master:', err);
    }
  };

  const fetchRekapSholat = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/absensi-sholat/rekap`, {
        ...authHeader,
        params: { asrama_id: selectedAsrama, tanggal }
      });
      setDataRekap(res.data);
    } catch (err) {
      console.error('Gagal mengambil rekap sholat:', err);
      setDataRekap([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchRekapPengayaan = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/absensi-pengayaan/rekap`, {
        ...authHeader,
        params: { kelompok_id: selectedPengayaan, tanggal }
      });
      setDataRekap(res.data);
    } catch (err) {
      console.error('Gagal mengambil rekap pengayaan:', err);
      setDataRekap([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      <h2 style={{ marginBottom: '20px' }}>🕌 Rekapitulasi Asrama & Pengayaan</h2>

      {/* --- TAB SWITCHER --- */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <button
          onClick={() => setActiveTab('sholat')}
          style={{
            padding: '10px 20px',
            borderRadius: '6px',
            border: 'none',
            cursor: 'pointer',
            backgroundColor: activeTab === 'sholat' ? '#0284c7' : '#e2e8f0',
            color: activeTab === 'sholat' ? '#ffffff' : '#334155',
            fontWeight: 'bold'
          }}
        >
          🕌 Absensi Sholat Asrama
        </button>
        <button
          onClick={() => setActiveTab('pengayaan')}
          style={{
            padding: '10px 20px',
            borderRadius: '6px',
            border: 'none',
            cursor: 'pointer',
            backgroundColor: activeTab === 'pengayaan' ? '#0284c7' : '#e2e8f0',
            color: activeTab === 'pengayaan' ? '#ffffff' : '#334155',
            fontWeight: 'bold'
          }}
        >
          📖 Absensi Pengayaan
        </button>
      </div>

      {/* --- FILTER CONTROL --- */}
      <div style={{ display: 'flex', gap: '20px', alignItems: 'center', marginBottom: '20px', backgroundColor: '#f8fafc', padding: '15px', borderRadius: '8px' }}>
        {activeTab === 'sholat' ? (
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>Gedung Asrama:</label>
            <select
              value={selectedAsrama}
              onChange={(e) => setSelectedAsrama(e.target.value)}
              style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
            >
              {asramaList.map((a) => (
                <option key={a.id} value={a.id}>{a.nama_asrama}</option>
              ))}
            </select>
          </div>
        ) : (
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>Kelompok Pengayaan:</label>
            <select
              value={selectedPengayaan}
              onChange={(e) => setSelectedPengayaan(e.target.value)}
              style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
            >
              {pengayaanList.map((p) => (
                <option key={p.id} value={p.id}>{p.nama_kelompok} ({p.mapel})</option>
              ))}
            </select>
          </div>
        )}

        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>Tanggal:</label>
          <input
            type="date"
            value={tanggal}
            onChange={(e) => setTanggal(e.target.value)}
            style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
          />
        </div>
      </div>

      {/* --- TABEL DATA --- */}
      {loading ? (
        <p>Memuat rekapitulasi data...</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #cbd5e1' }}>
              <th style={{ padding: '12px' }}>No</th>
              <th style={{ padding: '12px' }}>NIS / ID</th>
              <th style={{ padding: '12px' }}>Nama Siswa</th>
              <th style={{ padding: '12px' }}>Kelas</th>
              {activeTab === 'sholat' && <th style={{ padding: '12px' }}>Waktu Sholat</th>}
              <th style={{ padding: '12px' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {dataRekap.length > 0 ? (
              dataRekap.map((row, index) => (
                <tr key={index} style={{ borderBottom: '1px solid #e2e8f0' }}>
                  <td style={{ padding: '12px' }}>{index + 1}</td>
                  <td style={{ padding: '12px' }}>{row.nis || '-'}</td>
                  <td style={{ padding: '12px' }}>{row.nama_siswa || row.nama}</td>
                  <td style={{ padding: '12px' }}>{row.kelas}</td>
                  {activeTab === 'sholat' && <td style={{ padding: '12px' }}>{row.waktu_sholat || '-'}</td>}
                  <td style={{ padding: '12px', fontWeight: 'bold' }}>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      backgroundColor: row.status === 'Hadir' ? '#dcfce7' : row.status === 'Alpha' ? '#fee2e2' : '#fef3c7',
                      color: row.status === 'Hadir' ? '#15803d' : row.status === 'Alpha' ? '#b91c1c' : '#b45309'
                    }}>
                      {row.status}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={activeTab === 'sholat' ? 6 : 5} style={{ padding: '20px', textAlign: 'center', color: '#64748b' }}>
                  Belum ada catatan absensi pada tanggal ini.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default RekapAsramaPengayaan;